export default "__VITE_ASSET__BMb8170a__"